export const divisionByHundred = (amount: number) => {
  if (!amount) return amount;

  return Number(amount / 100);
};
